import { useLayoutEffect, useState } from 'react';

/** Keep fullscreen mobile overlays above the keyboard without disabling browser zoom. */
export const useMobileViewport = (enabled: boolean) => {
  const [viewport, setViewport] = useState<{ height: number; top: number }>();
  useLayoutEffect(() => {
    if (!enabled) return;
    const visual = window.visualViewport;
    const update = () => {
      if (visual && Math.abs(visual.scale - 1) > 0.01) return;
      setViewport({ height: visual?.height ?? window.innerHeight, top: visual?.offsetTop ?? 0 });
    };
    update();
    visual?.addEventListener('resize', update);
    visual?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      visual?.removeEventListener('resize', update);
      visual?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [enabled]);
  return enabled ? { top: viewport?.top ?? 0, height: viewport?.height ?? '100dvh', bottom: 'auto' } : {};
};
